export default __webpack_public_path__ + "static/media/shutterstock-women.763dae08.png";